
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/image-alt-text-generator",
      function () {
        return require("private-next-pages/app/tools/image-alt-text-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/image-alt-text-generator"])
      });
    }
  